import * as yup from 'yup';

export const AddStateSchema = yup.object({
  name: yup.string().required('State name is required'),
  displayName: yup.string(),
  isActive: yup.boolean(),
});
